import { render, staticRenderFns } from "./QueryCreateDialog.vue?vue&type=template&id=2b753c90"
import script from "./QueryCreateDialog.vue?vue&type=script&lang=ts"
export * from "./QueryCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports